import React from 'react';
import RemoteSensingDashboard from './RemoteSensingDashboard';

function App() {
  return (
    <div className="App">
      <RemoteSensingDashboard />
    </div>
  );
}

export default App;